'use client'

import { useState } from 'react'
import { ShieldAlert } from 'lucide-react'

import Modal from '@/components/Modal/Modal'
import SettingsDialogTrigger from '@/components/Settings/SettingsDialogTrigger'
import { settingsConfigHelp } from '@/components/Settings/configHelp'

import ProfanityRulesForm from './ProfanityRulesForm'

const ProfanityRulesSettings = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const closeModal = () => setIsModalOpen(false)

  return (
    <>
      <SettingsDialogTrigger
        icon={<ShieldAlert size={18} />}
        label="Profanity Rules"
        help={settingsConfigHelp.profanityRules}
        onClick={() => setIsModalOpen(true)}
      />

      <Modal isOpen={isModalOpen} onClose={closeModal} title="Profanity Rules" closeOnOutsideClick={false}>
        <ProfanityRulesForm onCancel={closeModal} onSaved={closeModal} />
      </Modal>
    </>
  )
}

export default ProfanityRulesSettings
